import { createContext, useContext, useState, useEffect, type ReactNode } from 'react';

type DashboardScope = 'mine' | 'all';

interface DashboardFilterContextType {
  scope: DashboardScope;
  setScope: (scope: DashboardScope) => void;
}

const DashboardFilterContext = createContext<DashboardFilterContextType | undefined>(undefined);

const DASHBOARD_SCOPE_STORAGE_KEY = 'poco-dashboard-scope';

export function DashboardFilterProvider({ children }: { children: ReactNode }) {
  const [scope, setScope] = useState<DashboardScope>(() => {
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem(DASHBOARD_SCOPE_STORAGE_KEY);
      return stored === 'mine' || stored === 'all' ? stored : 'all';
    }
    return 'all';
  });

  // Sync to localStorage
  useEffect(() => {
    localStorage.setItem(DASHBOARD_SCOPE_STORAGE_KEY, scope);
  }, [scope]);

  return (
    <DashboardFilterContext.Provider value={{ scope, setScope }}>
      {children}
    </DashboardFilterContext.Provider>
  );
}

export function useDashboardFilter() {
  const context = useContext(DashboardFilterContext);
  if (context === undefined) {
    throw new Error('useDashboardFilter must be used within a DashboardFilterProvider');
  }
  return context;
}
